import React from "react";
import { Link } from "react-router-dom";
import "../layouts/MasterFormsNavbar.scss";
import allProjects from "../assets/images/allProjects.svg";
import allCompany from "../assets/images/allCompany.svg";
import countries from "../assets/images/countries.svg";
import allDistributors from "../assets/images/allDistributors.svg";
import activeDistributors from "../assets/images/activeDistributors.svg";
import blockedDistributors from "../assets/images/blockedDistributors.svg";
import holdDistributor from "../assets/images/holdDistributor.svg";
import approvedCreditLimit from "../assets/images/approvedCreditLimit.svg";
import activeProjects from "../assets/images/activeProjects.svg";
import cancelled from "../assets/images/cancelled.svg";
import holdProject from "../assets/images/holdProject.svg";
import allCustomers from "../assets/images/allCustomers.svg";
import activeCustomers from "../assets/images/activeCustomers.svg";
import blockedCustomers from "../assets/images/blockedCustomers.svg";
import creditLimitsExpiring from "../assets/images/creditLimitsExpiring.svg";
import creditDetailsPending from "../assets/images/creditDetailsPending.svg";
import expiredDocuments from "../assets/images/expiredDocuments.svg";
import customerApprovedCreditLimit from "../assets/images/customerApprovedCreditLimit.svg";

const MasterFormsNavbar = () => {
  return (
    <div className="container-fluid master-forms-nav-bar">
      <div className="row ml-4 mr-4 mt-5">
        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
          <div className="card">
            <div className="card-header">
              <h6>Project master</h6>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                  <div className="card">
                    <Link to="/project-master">
                      <div className="card-body">
                        <img src={allProjects}></img>
                        <h5 className="mt-3">All Projects</h5>
                      </div>
                      <div className="card-footer">
                        <h6>1260</h6>
                      </div>
                    </Link>
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                  <div className="card">
                    <Link to="/project-master">
                      <div className="card-body">
                        <img src={activeProjects}></img>
                        <h5 className="mt-3">Quoted projects</h5>
                      </div>
                      <div className="card-footer">
                        <h6>240</h6>
                      </div>
                    </Link>
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                  <div className="card">
                    <Link to="/project-master">
                      <div className="card-body">
                        <img src={holdProject}></img>
                        <h5 className="mt-3">Not quoted projects</h5>
                      </div>
                      <div className="card-footer">
                        <h6>60</h6>
                      </div>
                    </Link>
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                  <div className="card">
                    <Link to="/add-new-project">
                      <div className="card-body add-new-project-card-body">
                        {/* <img src={cancelled}></img> */}
                        <i class="fas fa-plus"></i>
                        <h5 className="mt-3">Add new project</h5>
                      </div>
                      <div className="card-footer">
                        <h6>&nbsp; &nbsp; </h6>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xxl-2 col-xl-2 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
          <div className="card">
            <div className="card-header">
              <h6>Company master</h6>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                  <div className="card">
                    <Link to="/company-master">
                      <div className="card-body">
                        <img src={allCompany}></img>
                        <h5 className="mt-3">All companies</h5>
                      </div>
                      <div className="card-footer">
                        <h6>03</h6>
                      </div>
                    </Link>
                  </div>
                </div>
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                  <div className="card">
                    <Link to="/add-new-company">
                      <div className="card-body">
                        <i class="fas fa-plus"></i>
                        <h5 className="mt-3">Add new company</h5>
                      </div>
                      <div className="card-footer">
                        <h6>&nbsp; &nbsp; </h6>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xxl-2 col-xl-2 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
          <div className="card">
            <div className="card-header">
              <h6>Distributor master</h6>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                  <div className="card">
                    <Link to="/distributor-master">
                      <div className="card-body">
                        <img src={allDistributors}></img>
                        <h5 className="mt-3">All distributors</h5>
                      </div>
                      <div className="card-footer">
                        <h6>242</h6>
                      </div>
                    </Link>
                  </div>
                </div>
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                  <div className="card">
                    <Link to="/distributor-master">
                      <div className="card-body">
                        <i class="fas fa-plus"></i>
                        <h5 className="mt-3">Add new distributors</h5>
                      </div>
                      <div className="card-footer">
                        <h6>&nbsp; &nbsp; </h6>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xxl-2 col-xl-2 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
          <div className="card">
            <div className="card-header">
              <h6>Approval master</h6>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                  <div className="card">
                    <Link to="/approval-master">
                      <div className="card-body">
                        <img src={allCompany}></img>
                        <h5 className="mt-3">All Approval</h5>
                      </div>
                      <div className="card-footer">
                        <h6>593</h6>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xxl-2 col-xl-2 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
          <div className="card">
            <div className="card-header">
              <h6>Delivery & payment</h6>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                  <div className="card">
                    <Link to="/add-delivery-terms">
                      <div className="card-body">
                        <i class="fas fa-plus"></i>
                        <h5 className="mt-3">Add delivery terms</h5>
                      </div>
                      <div className="card-footer">
                        <h6>&nbsp; &nbsp; </h6>
                      </div>
                    </Link>
                  </div>
                </div>
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                  <div className="card">
                    <Link to="/add-payment-terms">
                      <div className="card-body">
                        <i class="fas fa-plus"></i>
                        <h5 className="mt-3">Add payment terms</h5>
                      </div>
                      <div className="card-footer">
                        <h6>&nbsp; &nbsp; </h6>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
          <div className="card">
            <div className="card-header">
              <h6>Customer master</h6>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                  <div className="d-flex">
                    <div className="card">
                      <Link to="/customer-master">
                        <div className="card-body">
                          <img src={allCustomers}></img>
                          <h5 className="mt-3">All customers</h5>
                        </div>
                        <div className="card-footer">
                          <h6>03</h6>
                        </div>
                      </Link>
                    </div>
                    <div className="card">
                      <Link to="/customer-master">
                        <div className="card-body">
                          <img src={activeCustomers}></img>
                          <h5 className="mt-3">Active customers</h5>
                        </div>
                        <div className="card-footer">
                          <h6>03</h6>
                        </div>
                      </Link>
                    </div>
                    <div className="card">
                      <Link to="/customer-master">
                        <div className="card-body">
                          <img src={blockedCustomers}></img>
                          <h5 className="mt-3">Blocked customers</h5>
                        </div>
                        <div className="card-footer">
                          <h6>03</h6>
                        </div>
                      </Link>
                    </div>
                    <div className="card">
                      <Link to="/customer-master">
                        <div className="card-body">
                          <img src={creditLimitsExpiring}></img>
                          <h5 className="mt-3">Credit limits expiring</h5>
                        </div>
                        <div className="card-footer">
                          <h6>03</h6>
                        </div>
                      </Link>
                    </div>
                    <div className="card">
                      <Link to="/customer-master">
                        <div className="card-body">
                          <img src={creditDetailsPending}></img>
                          <h5 className="mt-3">Credit details pending</h5>
                        </div>
                        <div className="card-footer">
                          <h6>03</h6>
                        </div>
                      </Link>
                    </div>
                    <div className="card">
                      <Link to="/customer-master">
                        <div className="card-body">
                          <img src={customerApprovedCreditLimit}></img>
                          <h5 className="mt-3">Approved credit limit</h5>
                        </div>
                        <div className="card-footer">
                          <h6>03</h6>
                        </div>
                      </Link>
                    </div>
                    <div className="card">
                      <Link to="/customer-master">
                        <div className="card-body">
                          <img src={expiredDocuments}></img>
                          <h5 className="mt-3">Expired documents</h5>
                        </div>
                        <div className="card-footer">
                          <h6>03</h6>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MasterFormsNavbar;
